<template>
<div class="dot-navigation" v-click-outside="outsideClick">
  <div class="dot-navigation--trigger icon icon-more-vertical1" @click="toggleVisible" v-if="items.length > 0"></div>
  <ul v-show="visible" class="dot-navigation--content">
    <li class="dot-navigation--content-item" :key="item.name" v-for="item in items">
      <router-link :to="{name: item.name}" @click.native="outsideClick">{{item.title}}</router-link>
    </li>
  </ul>
</div>
</template>
<script>

export default {
  props: {
    items: {}
  },
  data(){
    return {
      visible: false
    }
  },
  methods: {
    outsideClick(){
      this.visible = false
    },
    toggleVisible(){
      this.visible = !this.visible
    }
  }
}
</script>



// WEBPACK FOOTER //
// DotNavigation.vue?d459e9b0